import { Component, OnInit } from '@angular/core';

import { GoogleSsoClientCredentials } from '../../app-lite/google-sso/models/google-sso.client-credentials';
import { GoogleSsoService }           from '../../app-lite/google-sso/google-sso.service';
import { MessagesService }            from '../../app-lite/messages/messages.service';

import googleSsoIcon from 'icons/google-sso.svg';

@Component({
  selector   : 'wor-google-sign-in',
  template: require('./google-sso.sign-in.component.html')
})
export class GoogleSsoSignInComponent implements OnInit {
  public googleSsoIcon : string  = googleSsoIcon;
  public isVisible     : boolean = false;

  constructor (
    public  googleSsoService: GoogleSsoService,
    private messagesService : MessagesService
  ) {}

  ngOnInit () : void {
    this.googleSsoService.getClientCredentials()
    .then(( credentials : GoogleSsoClientCredentials ) => {
      this.isVisible = !!credentials?.client_id;
    })
    .catch(() => {
      this.isVisible = false;
    });
  }

  signIn () : void {
    this.googleSsoService.getClientCredentials()
    .then(( credentials : GoogleSsoClientCredentials ) => {
      const params = new URLSearchParams({
        client_id    : credentials.client_id,
        redirect_uri : this.googleSsoService.getRedirectUri(),
        response_type: 'code',
        scope        : 'openid profile email',
        state        : this.googleSsoService.generateState('login')
      });

      window.location.assign(`${ this.googleSsoService.loginUrl }?${ params.toString() }`);
    })
    .catch(error => this.messagesService.error(error));
  }
}
